import { render, staticRenderFns } from "./TopicCard.vue?vue&type=template&id=c3450a4c&scoped=true&"
import script from "./TopicCard.vue?vue&type=script&lang=js&"
export * from "./TopicCard.vue?vue&type=script&lang=js&"
import style0 from "./TopicCard.vue?vue&type=style&index=0&id=c3450a4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3450a4c",
  null
  
)

export default component.exports